export const ON_ERROR_EVENT_NAME = "onError";